module.exports = __webpack_public_path__ + "static/media/siggraph-19b.dbb726f0.jpg";